module.exports = __webpack_public_path__ + "img/revenue-streams-icon.5a43a547.svg";